<template>
  <section>
    <h4>Doc Options</h4>
    <el-select v-model="selectedDocOption" placeholder="Select Doc Option" class="mb-3">
        <el-option
        v-for="item in docOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
    </el-select>
    <div v-show="docOption != 'lowdoc'">
        <h4>Income &amp; Add Backs - Annual Amounts</h4>
        <el-table
        :class="`business-incomes`"
        :data="businessIncomeData"
        :summary-method="getSummaries"
        :show-summary="docOption == 'fulldoc'"
        style="width: 100%; margin-top: 20px"
        >
        <el-table-column prop="0" label="Item">
            <template slot-scope="scope">
            {{_.get(itemTitles, `${scope.row[0]}`)}}
            </template>
        </el-table-column>
        <el-table-column prop="1.0.value" align="right" header-align="center" label="Current Year">
            <template slot-scope="scope">
                <application-input isCurrency class="input-belt" v-model="scope.row[1][0].value"></application-input>
            </template>
        </el-table-column>
        <el-table-column prop="1.1.value" align="right" header-align="center" label="Previous Year">
            <template slot-scope="scope">
                <application-input v-if="_.get(scope.row, '1.1')"  isCurrency class="input-belt" v-model="scope.row[1][1].value"></application-input>
            </template>
        </el-table-column>
        <el-table-column v-if="show2YearsPrior" prop="1.2.value" align="right" header-align="center" label="2 Years Prior">
            <template slot-scope="scope">
                <application-input v-if="_.get(scope.row, '1.2')"  isCurrency class="input-belt" v-model="scope.row[1][2].value"></application-input>
            </template>
        </el-table-column>
        </el-table>
        <el-divider></el-divider>
        <el-form label-position="top" label-width="100px" :model="debt_servicing">
            <el-form-item label="Notes - Include details detailing the information from the above table, including non-recurring expenses, add backs and other information">
                <el-input type="textarea" :rows="4" placeholder="Enter notes here" v-model="debt_servicing.note"></el-input>
            </el-form-item>
        </el-form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "DebtServicing",
  components: {},
  props: {
    docOption: {
      // required: false
    },
    incomeCurrentYear: {
      // required: true
    },
    incomeLastYear: {
      // required: true
    },
    incomePreviousYear: {
        required: true
    },
    commercialDebtServicing: {
        required: true
    },
  },
  data() {
    return {
      debt_servicing: {
        totals: [
          {
            label: "current",
            value: 0
          },
          {
            label: "last",
            value: 0
          },
          {
            label: "previous",
            value: 0
          }
        ],
        note: ""
      },
      itemTitles: {
        "Turnover":"Turnover",
        "Assessed Tax Payable":"Assessed Tax Payable",
        "Net Profit":"Net Profit Before Tax (NPBT)",
        "Depreciation":"Depreciation",
        "HP / Lease Interest":"HP / Lease Interest",
        "Interest":"Interest Paid (other)",
        "Non-recurring expenses":"Non-recurring expenses",
        "Other Add Backs":"Other Add Backs",
      },
      frequencies: [
        { count: 52, value: 4, days: 7 },
        { count: 26, value: 2, days: 14 },
        { count: 12, value: 1, days: (this.$moment().isLeapYear() ? 366 : 365 ) / 12 },
        { count: 4, value: 0.333333333, days: (this.$moment().isLeapYear() ? 366 : 365 ) / 4 },
        { count: 1, value: 0.083333333, days: (this.$moment().isLeapYear() ? 366 : 365 ) }
      ],
       docOptions: [{
          value: 'lowdoc',
          label: 'Low Doc'
        }, {
          value: 'litedoc',
          label: 'Lite Doc'
        }, {
          value: 'fulldoc',
          label: 'Full Doc'
        }],
    }
  },
  computed: {
    ...mapGetters({
        financeDetails: "summary/financeDetails",
    }),
    selectedDocOption: {
        get: function () {
            return this.docOption;
        },
        set: function (newOption) {
            this.$emit("update:docOption", newOption)
        }
    },
    businessIncomeData() {
        let combined = _.mapValues(_.groupBy([..._.values(this.incomeCurrentYear), ..._.values(this.incomeLastYear), ..._.values(this.incomePreviousYear)], 'label'));
        let combinedArray = Object.entries(combined);

        if (this.docOption == 'litedoc') {
            combinedArray = _.filter(combinedArray, function(o) { return _.get(o, '0') == 'Net Profit' ||  _.get(o, '0') == 'Turnover'; });
        }

        this.debt_servicing.details = combinedArray;
        return combinedArray;
    },
    show2YearsPrior() {
        return !_.isUndefined(this.incomePreviousYear);
    }
  },
  watch: {
    incomeCurrentYear: {
      handler(after, before) {
        this.$emit("update:incomeCurrentYear", this.incomeCurrentYear)
      },
      deep: true
    },
    incomeLastYear: {
      handler(after, before) {
        this.$emit("update:incomeLastYear", this.incomeLastYear)
      },
      deep: true
    },
    incomePreviousYear: {
      handler(after, before) {
        this.$emit("update:incomePreviousYear", this.incomePreviousYear)
      },
      deep: true
    },
    "debt_servicing.totals": {
      handler(after, before) {
        this.$emit("update:commercialDebtServicing", this.debt_servicing);
        this.$store.dispatch('commercial/saveBusinessIncomeTotals', this.debt_servicing.totals);
      },
      immediate: true
    }
  },
  mounted() {
  },
  updated() {},
  activated() {},
  methods: {
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'EBITDA';
            return;
          }

          const values = data.map(item => {
            return {
                v: Number(_.get(item, column.property)),
                label: _.get(item, '0')
            }
          })

          if (!values.every(value => isNaN(value.v))) {
            let currentColumnTotals = values.reduce((prev, curr) => {
              const value = Number(curr.v);
              if (!isNaN(value)) {
                  if (curr.label == 'Assessed Tax Payable' || curr.label == 'Turnover') {
                      return prev;
                    //   return prev - curr.v;
                  } else {
                      return prev + curr.v;
                  }
              } else {
                return prev;
              }
            }, 0);

          sums[index] = this.formatCurrency(currentColumnTotals, 2)
          this.debt_servicing.totals[`${index - 1}`].value = currentColumnTotals
        } else {
          sums[index] = ""
          this.debt_servicing.totals[`${index - 1}`].value = 0
        }
        });

        return sums;
    },
    formatCurrency(amount, decimals = 0) {
        let currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        })
        return currencyFormatter.format(amount)
    },

  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
h4 {
    padding: 0.5rem 1rem;
    color: #2493ef!important;
    font-size: 1.1rem !important;
}
</style>
<style lang="scss">
.currency {
  input {
    text-align: right;
  }
}
.business-incomes {
    .el-table__footer {
        td {
            font-weight: 900 !important;
        }
    }
}

</style>
